<template>
  <div class="body-div">
    <div class="top-div">
      <div class="endpoint-calls">
        <button v-on:click="getDepositAssignmentReport">
          Get Deposit Assignment Report
        </button>
      </div>
      <span v-if="report['users']">
        The averages are displayed in hours

        <table id="myTable" v-if="report['users']">
          <tr>
            <th>
              Users
              <button
                @click="applySorting(0, 0)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-alpha-down': sortOrder[0] === 'asc',
                    'fas fa-sort-alpha-up': sortOrder[0] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              D-avg
              <button
                @click="applySorting(3, 1)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[3] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[3] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              Time(H)
              <button
                @click="applySorting(1, 2)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              Dep
              <button
                @click="applySorting(2, 3)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[2] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[2] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              W-avg
              <button
                @click="applySorting(3, 4)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[3] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[3] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              Time(H)
              <button
                @click="applySorting(1, 5)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              Dep
              <button
                @click="applySorting(2, 6)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[2] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[2] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              M-avg
              <button
                @click="applySorting(3, 7)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[3] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[3] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              Time(H)
              <button
                @click="applySorting(1, 8)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              Dep
              <button
                @click="applySorting(2, 9)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[2] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[2] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              Q-avg
              <button
                @click="applySorting(3, 10)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[3] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[3] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              Time(H)
              <button
                @click="applySorting(1, 11)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              Dep
              <button
                @click="applySorting(2, 12)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[2] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[2] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              HY-avg
              <button
                @click="applySorting(3, 13)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[3] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[3] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              Time(H)
              <button
                @click="applySorting(1, 14)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              Dep
              <button
                @click="applySorting(2, 15)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[2] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[2] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              Y-avg
              <button
                @click="applySorting(3, 16)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[3] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[3] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="border-divider">
              Time(H)
              <button
                @click="applySorting(1, 17)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              Dep
              <button
                @click="applySorting(2, 18)"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[2] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[2] === 'desc'
                  }"
                ></span>
              </button>
            </th>
          </tr>
          <tr v-for="user in report['users']" v-bind:key="user" :id="user.id">
            <td>
              {{ salesPersonList.find(item => item.id === user.id).full_name }}
            </td>
            <td>
              {{ user["time_frames"][0].average }}
              <span
                v-if="user['time_frames'][0].average > 0"
                :class="
                  report['call_center'].find(
                    item => item.id === user['time_frames'][0].id
                  ).average -
                    user['time_frames'][0].average >=
                  0
                    ? 'positive'
                    : 'negative'
                "
                ><span
                  v-if="
                    report['call_center'].find(
                      item => item.id === user['time_frames'][0].id
                    ).average -
                      user['time_frames'][0].average >=
                      0
                  "
                  >+</span
                >{{
                  (
                    report["call_center"].find(
                      item => item.id === user["time_frames"][0].id
                    ).average - user["time_frames"][0].average
                  ).toFixed(1)
                }}</span
              >
            </td>
            <td>
              {{ user["time_frames"][0].time_diff }}
            </td>
            <td>
              {{ user["time_frames"][0].deposits }}
            </td>

            <td>
              {{ user["time_frames"][1].average }}
              <span
                v-if="user['time_frames'][1].average > 0"
                :class="
                  report['call_center'].find(
                    item => item.id === user['time_frames'][1].id
                  ).average -
                    user['time_frames'][1].average >=
                  0
                    ? 'positive'
                    : 'negative'
                "
                ><span
                  v-if="
                    report['call_center'].find(
                      item => item.id === user['time_frames'][1].id
                    ).average -
                      user['time_frames'][1].average >=
                      0
                  "
                  >+</span
                >{{
                  (
                    report["call_center"].find(
                      item => item.id === user["time_frames"][1].id
                    ).average - user["time_frames"][1].average
                  ).toFixed(1)
                }}</span
              >
            </td>
            <td>
              {{ user["time_frames"][1].time_diff }}
            </td>
            <td>
              {{ user["time_frames"][1].deposits }}
            </td>

            <td>
              {{ user["time_frames"][2].average }}
              <span
                v-if="user['time_frames'][2].average > 0"
                :class="
                  report['call_center'].find(
                    item => item.id === user['time_frames'][2].id
                  ).average -
                    user['time_frames'][2].average >=
                  0
                    ? 'positive'
                    : 'negative'
                "
                ><span
                  v-if="
                    report['call_center'].find(
                      item => item.id === user['time_frames'][2].id
                    ).average -
                      user['time_frames'][2].average >=
                      0
                  "
                  >+</span
                >{{
                  (
                    report["call_center"].find(
                      item => item.id === user["time_frames"][2].id
                    ).average - user["time_frames"][2].average
                  ).toFixed(1)
                }}</span
              >
            </td>
            <td>
              {{ user["time_frames"][2].time_diff }}
            </td>
            <td>
              {{ user["time_frames"][2].deposits }}
            </td>

            <td>
              {{ user["time_frames"][3].average }}
              <span
                v-if="user['time_frames'][3].average > 0"
                :class="
                  report['call_center'].find(
                    item => item.id === user['time_frames'][3].id
                  ).average -
                    user['time_frames'][3].average >=
                  0
                    ? 'positive'
                    : 'negative'
                "
                ><span
                  v-if="
                    report['call_center'].find(
                      item => item.id === user['time_frames'][3].id
                    ).average -
                      user['time_frames'][3].average >=
                      0
                  "
                  >+</span
                >{{
                  (
                    report["call_center"].find(
                      item => item.id === user["time_frames"][3].id
                    ).average - user["time_frames"][3].average
                  ).toFixed(1)
                }}</span
              >
            </td>
            <td>
              {{ user["time_frames"][3].time_diff }}
            </td>
            <td>
              {{ user["time_frames"][3].deposits }}
            </td>

            <td>
              {{ user["time_frames"][4].average }}
              <span
                v-if="user['time_frames'][4].average > 0"
                :class="
                  report['call_center'].find(
                    item => item.id === user['time_frames'][4].id
                  ).average -
                    user['time_frames'][4].average >=
                  0
                    ? 'positive'
                    : 'negative'
                "
                ><span
                  v-if="
                    report['call_center'].find(
                      item => item.id === user['time_frames'][4].id
                    ).average -
                      user['time_frames'][4].average >=
                      0
                  "
                  >+</span
                >{{
                  (
                    report["call_center"].find(
                      item => item.id === user["time_frames"][4].id
                    ).average - user["time_frames"][4].average
                  ).toFixed(1)
                }}</span
              >
            </td>
            <td>
              {{ user["time_frames"][4].time_diff }}
            </td>
            <td>
              {{ user["time_frames"][4].deposits }}
            </td>

            <td>
              {{ user["time_frames"][5].average }}
              <span
                v-if="user['time_frames'][5].average > 0"
                :class="
                  report['call_center'].find(
                    item => item.id === user['time_frames'][5].id
                  ).average -
                    user['time_frames'][5].average >=
                  0
                    ? 'positive'
                    : 'negative'
                "
                ><span
                  v-if="
                    report['call_center'].find(
                      item => item.id === user['time_frames'][5].id
                    ).average -
                      user['time_frames'][5].average >=
                      0
                  "
                  >+</span
                >{{
                  (
                    report["call_center"].find(
                      item => item.id === user["time_frames"][5].id
                    ).average - user["time_frames"][5].average
                  ).toFixed(1)
                }}</span
              >
            </td>
            <td>
              {{ user["time_frames"][5].time_diff }}
            </td>
            <td>
              {{ user["time_frames"][5].deposits }}
            </td>
            <td class="avg-data-column">
              <span v-if="user.id == highlightedRow && sumAvg > 0">{{
                sumAvg
              }}</span>
            </td>
          </tr>
        </table>

        <hr />
        <table v-if="report['call_center']">
          <tr>
            <th>Time frame</th>
            <th>Call center average</th>
          </tr>
          <tr v-for="time in report['call_center']" v-bind:key="time">
            <td>{{ time.id }}</td>
            <td>{{ time.average }}</td>
          </tr>
        </table>
      </span>

      <loader class="loader" :size="'8px'" v-if="reportBusy"></loader>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
export default {
  name: "AssignmentDepositReport.container",
  components: { Loader },
  data() {
    return {
      sortOrder: {
        0: "desc",
        1: "desc",
        2: "desc",
        3: "desc"
      },
      highlightedRow: 0,
      sumAvg: 0,
      reportBusy: false,
      report: []
    };
  },
  mixins: [UsersPermissionCheck],
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  mounted() {
    this.getDepositAssignmentReport();
  },
  methods: {
    sortIt(info) {
      let keys = Object.keys(info.users);
      let tempArr = [];
      keys.map(key => {
        tempArr.push(info.users[key]);
      });
      let flattedArray = tempArr.sort((a, b) => {
        if (a["time_frames"][2].average > b["time_frames"][2].average) {
          return -1;
        }
        if (a["time_frames"][2].average < b["time_frames"][2].average) {
          return 1;
        }
        return 0;
      });

      info.users = flattedArray;
      return info;
    },
    async getDepositAssignmentReport() {
      this.report = [];
      if (!this.reportBusy && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            "reports/deposits_assignment/time_diff/report/true"
          ).get("");
          let arr = this.sortIt(res.data);
          this.report = arr;
          this.reportBusy = false;
        } catch (e) {}
      }
    },
    applySorting(typeSort, tableColumn) {
      let table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        switchcount = 0;
      table = document.getElementById("myTable");
      switching = true;
      this.sortOrder[typeSort] = "desc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 1; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[tableColumn];
          y = rows[i + 1].getElementsByTagName("TD")[tableColumn];
          if (this.sortOrder[typeSort] === "desc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else if (typeSort === 3) {
              if (
                Number(x.innerHTML.split("<")[0]) <
                Number(y.innerHTML.split("<")[0])
              ) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else if (this.sortOrder[typeSort] === "asc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else if (typeSort === 3) {
              if (
                Number(x.innerHTML.split("<")[0]) >
                Number(y.innerHTML.split("<")[0])
              ) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount === 0 && this.sortOrder[typeSort] === "desc") {
            this.sortOrder[typeSort] = "asc";
            switching = true;
          }
        }
      }
      let counter = 0;
      this.sumAvg = 0;
      for (i = 1; i < rows.length - 1; i++) {
        if (this.highlightedRow !== 0) {
          document.getElementById(this.highlightedRow).style.borderTop = "none";
        }
        let checkedRow = rows[i].getElementsByTagName("TD")[tableColumn];
        let checkedSpan = checkedRow.getElementsByTagName("SPAN");
        if (checkedSpan.length > 0) {
          if (this.sortOrder[typeSort] === "desc") {
            if (checkedSpan[0].classList.contains("negative")) {
              counter += 1;
              let content = checkedSpan[0].innerHTML.split("-");
              this.sumAvg += Number(content[content.length - 1]);
            }
            if (checkedSpan[0].classList.contains("positive")) {
              document.getElementById(rows[i].id).style.borderTop =
                "5px solid blue";
              this.highlightedRow = rows[i].id;
              this.sumAvg = (this.sumAvg / Math.max(1, counter)).toFixed(1);
              break;
            }
          } else {
            if (checkedSpan[0].classList.contains("positive")) {
              counter += 1;
              let content = checkedSpan[0].innerHTML.split(">");
              this.sumAvg += Number(content[content.length - 1]);
            }
            if (checkedSpan[0].classList.contains("negative")) {
              document.getElementById(rows[i].id).style.borderTop =
                "5px solid blue";
              this.highlightedRow = rows[i].id;
              this.sumAvg = (this.sumAvg / Math.max(1, counter)).toFixed(1);
              break;
            }
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px 1em;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.1em 0.3em;
  font-size: 0.78vw;
  overflow: hidden;
  white-space: nowrap;
}
.loader {
  left: 0;
  right: 0;
}

.endpoint-calls {
  display: flex;
  justify-content: center;
  padding: 2em 0;
}
.overall-call-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.border-divider {
  border-right: 2px solid transparent;
}
.positive {
  color: green;
}
.negative {
  color: red;
}
.btn-sm {
  font-size: 0.8vw;
  padding: 2px 4px;
  outline: none;
  border: none;
}
.btn-sm:active {
  border: none;
  outline: none;
  background: #e0e0e0;
}
.btn-sm:focus {
  border: none;
  outline: none;
}
.avg-data-column {
  border: 1px solid transparent;
}
</style>
